import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePaymentMethod } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { PaymentMethodDto } from '@/types/subscription';

export const useDeletePaymentMethod = () => {
    const queryClient = useQueryClient();
    return useMutation<PaymentMethodDto, unknown, string>({
        mutationFn: deletePaymentMethod,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.paymentMethods() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
        },
    });
};
